export function getQuoteConverted(quote) {
  return {
    ...quote,
    premiumLiquid: quote.premium - quote.iofValue
  };
}
